import * as Sentry from '@sentry/nextjs'
import { isDevelopment } from './lib/shared/environments'

Sentry.init({
  dsn: !isDevelopment && process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_LISTERI_ENV,
  tags: { environment: process.env.NEXT_PUBLIC_LISTERI_ENV },
  tracesSampleRate: 1.0
})
